import React from 'react';

import { DayPickerWithField } from 'components/DatePicker';
import { GenderWithField } from 'components/GenderButtons/GenderButtons';
import { InputWithField } from 'components/Input';
import { PhoneNumberField } from 'components/PhoneNumberField';
import { YesNoRadioGroupWithField } from 'components/YesNoRadioGroup';
import { translations } from 'new/form/common/types';
import { LegalRepresentative } from 'pages/operationPortal/CompaniesDetails/AssiciatedPerson/components/legalRepresentatives/fields';
import {
  FieldConfig,
  useGenerateField,
} from 'pages/operationPortal/CompaniesDetails/AssiciatedPerson/formFields/useGenerateField';
import { AssociatedPersonMode } from 'pages/operationPortal/CompaniesDetails/AssiciatedPerson/types';

const { fields } = translations.pages.companiesDetails.associatedPerson.new.legalRepresentatives;

export type LegalRepresentativeFieldsWithoutId = Omit<LegalRepresentative, 'id'>;

export type LegalRepresentativeFields = Record<
  keyof LegalRepresentativeFieldsWithoutId,
  React.ReactNode
>;

export const legalRepresentativeFieldConfig: FieldConfig<LegalRepresentativeFieldsWithoutId> = {
  salutation: {
    component: GenderWithField,
    caption: fields.salutation.caption,
  },
  firstName: {
    component: InputWithField,
    caption: fields.firstName.caption,
  },
  lastName: {
    component: InputWithField,
    caption: fields.lastName.caption,
  },
  birthDate: {
    componentProps: () => ({
      maxDate: Date.now(),
    }),
    component: DayPickerWithField,
    caption: fields.birthDate.caption,
  },
  email: {
    component: InputWithField,
    caption: fields.email.caption,
  },
  phoneNumber: {
    component: PhoneNumberField,
    caption: fields.phoneNumber.caption,
  },
  soleSignatureAuthorized: {
    component: YesNoRadioGroupWithField,
    caption: fields.soleSignatureAuthorized.inquiryCaption,
  },
};

export function useGenerateLegalRepresentativeFields(
  mode: AssociatedPersonMode,
  prefix?: string,
): LegalRepresentativeFields {
  const generateField = useGenerateField<LegalRepresentativeFieldsWithoutId>(
    legalRepresentativeFieldConfig,
    mode,
    prefix,
  );

  return {
    salutation: generateField('salutation'),
    firstName: generateField('firstName'),
    lastName: generateField('lastName'),
    birthDate: generateField('birthDate'),
    email: generateField('email'),
    phoneNumber: generateField('phoneNumber'),
    soleSignatureAuthorized: generateField('soleSignatureAuthorized'),
  };
}
